export default "__VITE_ASSET__BLS94QhW__"